import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllAccessPlans,
  fetchAllDraftPlans,
  fetchBiomaxRegisteredMembers,
  fetchCentralisedPlanCategories,
  fetchCentralisedPlans,
  fetchMemberSubscription,
  fetchODMStats,
  fetchOneDayPlans,
  fetchPlanOffers,
  fetchRecurringSubscriptions,
  fetchRecurringSubscriptionStats,
  fetchTestingNumbers,
  fetchUpgradeMemberships,
  fetchWebsiteTabPrefence,
  fetchAllAddonDrafts,
  fetchAllPlanPause,
  fetchMembershipPause,
  fetchTriggers,
  fetchOfferAttributes,
  fetchInventories,
  fetchTriggersDays,
  fetchPlans,
  fetchThreeDayPTTrial,
  fetchMemberTrialHistory,
  fetchSubscriptionExtensionRequests,
  fetchManualExtensionData,
  fetchMemberDetailsByMobile,
  fetchTrialSessionDetails,
  fetchTrainerPTRenewals,
  fetchPaymentLinkHomeStat,
  fetchThreeDayPTMemberDetails,
  fetchThreeDayPTSessionStats,
  fetchThreeDayPTMembersStats,
  fetchAddonCategories,
  fetchAddonCarryItems,
  fetchAddonBenefits,
  fetchTrainerTrialReport,
  fetchTrainerTrialReportUsers,
  fetchUpgradePtMemberships,
  fetchPtUpgradeAddons,
  fetchOngoingOffers,
} from "./plansApis";
import {
  fetchMemberDietStatsData,
  fetchMemberTmeDietStatsData,
  fetchNutritionLogs14DaysData,
} from "./plansApis";

// 3-Day PT Trial — Trainer Trial Report (ported from main). Read-only.
export const fetchTrainerTrialReportData = createAsyncThunk(
  "plans/fetchTrainerTrialReportData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchTrainerTrialReport(filters, token);
    return response;
  }
);

export const fetchTrainerTrialReportUsersData = createAsyncThunk(
  "plans/fetchTrainerTrialReportUsersData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchTrainerTrialReportUsers(filters, token);
    return response;
  }
);

export const fetchAllDraftPlansData = createAsyncThunk(
  "api/fetchAllDraftPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllDraftPlans(filters, token);
    return response;
  }
);

export const fetchPlanOffersData = createAsyncThunk(
  "api/fetchPlanOffersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPlanOffers(filters, token);
    return response;
  }
);

// All Gym Offers (ongoing_offer) — ported from main. Read-only display.
export const fetchOngoingOffersData = createAsyncThunk(
  "plans/fetchOngoingOffersData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchOngoingOffers(filters, token);
    return response;
  }
);

export const fetchOneDayPlansData = createAsyncThunk(
  "plans/fetchOneDayPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchOneDayPlans(filters, token);
    return response;
  }
);

export const fetchODMStatsData = createAsyncThunk(
  "plans/fetchODMStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchODMStats(filters, token);
    return response;
  }
);

export const fetchMemberSubscriptionData = createAsyncThunk(
  "plans/fetchMemberSubscriptionData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMemberSubscription(filters, token);
    return response;
  }
);

export const fetchTestingNumbersData = createAsyncThunk(
  "plans/fetchTestingNumbersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTestingNumbers(filters, token);
    return response;
  }
);

export const fetchUpgradeMembershipsData = createAsyncThunk(
  "plans/fetchUpgradeMembershipsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUpgradeMemberships(filters, token);
    return response;
  }
);

// PT (addon_pt) membership upgrade — ported from main
export const fetchUpgradePtMembershipsData = createAsyncThunk(
  "plans/fetchUpgradePtMembershipsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchUpgradePtMemberships(filters, token);
    return response;
  }
);

export const fetchPtUpgradeAddonsData = createAsyncThunk(
  "plans/fetchPtUpgradeAddonsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPtUpgradeAddons(filters, token);
    return response;
  }
);

export const fetchBiomaxRegisteredMembersData = createAsyncThunk(
  "plans/fetchBiomaxRegisteredMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBiomaxRegisteredMembers(filters, token);
    return response;
  }
);

export const fetchAllAccessPlansData = createAsyncThunk(
  "plans/fetchAllAccessPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllAccessPlans(filters, token);
    return response;
  }
);

export const fetchRecurringSubscriptionsData = createAsyncThunk(
  "plans/fetchRecurringSubscriptionsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRecurringSubscriptions(filters, token);
    return response;
  }
);

export const fetchRecurringSubscriptionStatsData = createAsyncThunk(
  "plans/fetchRecurringSubscriptionStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRecurringSubscriptionStats(filters, token);
    return response;
  }
);

export const fetchWebsiteTabPrefenceData = createAsyncThunk(
  "plans/fetchWebsiteTabPrefenceData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWebsiteTabPrefence(filters, token);
    return response;
  }
);

export const fetchCentralisedPlansData = createAsyncThunk(
  "plans/fetchCentralisedPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCentralisedPlans(filters, token);
    return response;
  }
);

export const fetchCentralisedPlanCategoriesData = createAsyncThunk(
  "plans/fetchCentralisedPlanCategoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCentralisedPlanCategories(filters, token);
    return response;
  }
);

export const fetchAllAddonDraftsData = createAsyncThunk(
  "plans/fetchAllAddonDraftsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllAddonDrafts(filters, token);
    return response;
  }
);

export const fetchAllPlanPauseData = createAsyncThunk(
  "plans/fetchAllPlanPauseData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAllPlanPause(filters, token);
    return response;
  }
);

export const fetchMembershipPauseData = createAsyncThunk(
  "plans/fetchMembershipPauseData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMembershipPause(filters, token);
    return response;
  }
);

export const fetchOfferAttributesData = createAsyncThunk(
  "plans/fetchOfferAttributesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchOfferAttributes(filters, token);
    return response;
  }
);

export const fetchTriggersData = createAsyncThunk(
  "plans/fetchTriggersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTriggers(filters, token);
    return response;
  }
);

export const fetchTriggersDaysData = createAsyncThunk(
  "plans/fetchTriggersDaysData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTriggersDays(filters, token);
    return response;
  }
);

export const fetchInventoriesData = createAsyncThunk(
  "plans/fetchInventoriesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchInventories(filters, token);
    return response;
  }
);

export const fetchPlansData = createAsyncThunk(
  "plans/fetchPlansData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPlans(filters, token);
    return response;
  }
);

export const fetchThreeDayPTTrialData = createAsyncThunk(
  "plans/fetchThreeDayPTTrialData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchThreeDayPTTrial(filters, token);
    return response;
  }
);

export const fetchMemberTrialHistoryData = createAsyncThunk(
  "plans/fetchMemberTrialHistoryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMemberTrialHistory(filters, token);
    return response;
  }
);

export const fetchSubscriptionExtensionRequestsData = createAsyncThunk(
  "plans/fetchSubscriptionExtensionRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchSubscriptionExtensionRequests(filters, token);
    return response;
  }
);

export const fetchManualExtensionDataData = createAsyncThunk(
  "plans/fetchManualExtensionDataData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchManualExtensionData(filters, token);
    return response;
  }
);

export const fetchMemberDetailsByMobileData = createAsyncThunk(
  "plans/fetchMemberDetailsByMobileData",
  async (payload, { getState }) => {
    const { mobile, token } = payload;
    const response = await fetchMemberDetailsByMobile(mobile, token);
    return response;
  }
);

export const fetchTrialSessionDetailsData = createAsyncThunk(
  "plans/fetchTrialSessionDetailsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrialSessionDetails(filters, token);
    return response;
  }
);

export const fetchMemberDietStats = createAsyncThunk(
  "plans/fetchMemberDietStats",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchMemberDietStatsData(filters, token);
    return response;
  }
);

export const fetchMemberTmeDietStats = createAsyncThunk(
  "plans/fetchMemberTmeDietStats",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchMemberTmeDietStatsData(filters, token);
    return response;
  }
);

export const fetchNutritionLogs14Days = createAsyncThunk(
  "plans/fetchNutritionLogs14Days",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchNutritionLogs14DaysData(filters, token);
    return response;
  }
);

export const fetchTrainerPTRenewalsData = createAsyncThunk(
  "plans/fetchTrainerPTRenewalsData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchTrainerPTRenewals(filters, token);
    return response;
  }
);

export const fetchPaymentLinkHomeStatData = createAsyncThunk(
  "plans/fetchPaymentLinkHomeStatData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchPaymentLinkHomeStat(filters, token);
    return response;
  }
);

export const fetchThreeDayPTMemberDetailsData = createAsyncThunk(
  "plans/fetchThreeDayPTMemberDetailsData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchThreeDayPTMemberDetails(filters, token);
    return response;
  }
);

export const fetchThreeDayPTSessionStatsData = createAsyncThunk(
  "plans/fetchThreeDayPTSessionStatsData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchThreeDayPTSessionStats(filters, token);
    return response;
  }
);

export const fetchThreeDayPTMembersStatsData = createAsyncThunk(
  "plans/fetchThreeDayPTMembersStatsData",
  async (payload) => {
    const { filters, token } = payload;
    const { page, limit, ...statsFilters } = filters || {};
    const response = await fetchThreeDayPTMembersStats(statsFilters, token);
    return response;
  }
);

export const fetchAddonCategoriesData = createAsyncThunk(
  "plans/fetchAddonCategoriesData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchAddonCategories(filters, token);
    return response;
  }
);

export const fetchAddonCarryItemsData = createAsyncThunk(
  "plans/fetchAddonCarryItemsData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchAddonCarryItems(filters, token);
    return response;
  }
);

export const fetchAddonBenefitsData = createAsyncThunk(
  "plans/fetchAddonBenefitsData",
  async (payload) => {
    const { filters, token } = payload;
    const response = await fetchAddonBenefits(filters, token);
    return response;
  }
);

const planSlice = createSlice({
  name: "plans",
  initialState: {
    plansData: null,
    draftPlans: null,
    plansError: "",
    plansLoading: false,

    // All Gym Offers (ongoing_offer)
    ongoingOffers: null,
    ongoingOffersLoading: false,
    ongoingOffersError: null,

    oneDayPlansData: null,
    oneDayPlansError: "",
    oneDayPlansLoading: false,

    oneDayStats: null,
    oneDayStatsError: "",
    oneDayStatsLoading: false,

    memberSubscription: null,
    memberSubscriptionLoading: false,
    memberSubscriptionError: null,

    testingNumbers: null,
    testingNumbersLoading: false,
    testingNumbersError: null,

    upgradeMemberships: null,
    upgradeMembershipsLoading: false,
    upgradeMembershipsError: null,

    // PT (addon_pt) membership upgrade — ported from main
    upgradePtMemberships: null,
    upgradePtMembershipsLoading: false,
    upgradePtMembershipsError: null,

    ptUpgradeAddons: null,
    ptUpgradeAddonsLoading: false,
    ptUpgradeAddonsError: null,

    biomaxRegisteredMembers: null,
    biomaxRegisteredMembersLoading: false,
    biomaxRegisteredMembersError: null,

    allAccessPlans: null,
    allAccessPlansLoading: false,
    allAccessPlansError: null,

    recurringSubscription: null,
    recurringSubscriptionLoading: false,
    recurringSubscriptionError: null,

    recurringSubscriptionStats: null,
    recurringSubscriptionStatsLoading: false,
    recurringSubscriptionStatsError: null,

    websiteTabPrefence: null,
    websiteTabPrefenceLoading: false,
    websiteTabPrefenceError: null,

    centralisedPlans: null,
    centralisedPlansLoading: false,
    centralisedPlansError: null,

    centralisedPlanCategories: null,
    centralisedPlanCategoriesLoading: false,
    centralisedPlanCategoriesError: null,

    addonDrafts: null,
    addonDraftsLoading: false,
    addonDraftsError: null,

    planPause: null,
    planPauseLoading: false,
    planPauseError: null,

    membershipPause: null,
    membershipPauseLoading: false,
    membershipPauseError: null,

    offerAttributes: null,
    offerAttributesLoading: false,
    offerAttributesError: null,

    triggers: null,
    triggersLoading: false,
    triggersError: null,

    triggersDays: null,
    triggersDaysLoading: false,
    triggersDaysError: null,

    inventories: null,
    inventoriesLoading: false,
    inventoriesError: null,

    plansV0: null,
    plansLoadingV0: false,
    plansErrorV0: null,

    threeDayPTTrial: null,
    threeDayPTTrialLoading: false,
    threeDayPTTrialError: null,

    memberTrialHistory: null,
    memberTrialHistoryLoading: false,
    memberTrialHistoryError: null,

    subscriptionExtensionRequests: null,
    subscriptionExtensionRequestsLoading: false,
    subscriptionExtensionRequestsError: null,

    manualExtensionData: null,
    manualExtensionDataLoading: false,
    manualExtensionDataError: null,

    memberDetailsByMobile: null,
    memberDetailsByMobileLoading: false,
    memberDetailsByMobileError: null,

    trialSessionDetails: null,
    trialSessionDetailsLoading: false,
    trialSessionDetailsError: null,

    memberDietStats: null,
    memberDietStatsLoading: false,
    memberDietStatsError: null,

    memberTmeDietStats: null,
    memberTmeDietStatsLoading: false,
    memberTmeDietStatsError: null,

    nutritionLogs14Days: null,
    nutritionLogs14DaysLoading: false,
    nutritionLogs14DaysError: null,

    trainerPTRenewals: null,
    trainerPTRenewalsLoading: false,
    trainerPTRenewalsError: null,

    paymentLinkHomeStat: null,
    paymentLinkHomeStatLoading: false,
    paymentLinkHomeStatError: null,

    threeDayPTMemberDetails: null,
    threeDayPTMemberDetailsLoading: false,
    threeDayPTMemberDetailsError: null,

    threeDayPTSessionStats: null,
    threeDayPTSessionStatsLoading: false,
    threeDayPTSessionStatsError: null,

    threeDayPTMembersStats: null,
    threeDayPTMembersStatsLoading: false,
    threeDayPTMembersStatsError: null,

    addonCategories: null,
    addonCategoriesLoading: false,
    addonCategoriesError: null,

    addonCarryItems: null,
    addonCarryItemsLoading: false,
    addonCarryItemsError: null,

    addonBenefits: null,
    addonBenefitsLoading: false,
    addonBenefitsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 3-Day PT Trial — Trainer Trial Report (ported from main)
      .addCase(fetchTrainerTrialReportData.pending, (state) => {
        state.trainerTrialReportLoading = true;
        state.trainerTrialReportError = null;
      })
      .addCase(fetchTrainerTrialReportData.fulfilled, (state, action) => {
        state.trainerTrialReportLoading = false;
        state.trainerTrialReport = action.payload;
      })
      .addCase(fetchTrainerTrialReportData.rejected, (state, action) => {
        state.trainerTrialReportLoading = false;
        state.trainerTrialReportError = action.error.message;
      })
      .addCase(fetchTrainerTrialReportUsersData.pending, (state) => {
        state.trainerTrialReportUsersLoading = true;
        state.trainerTrialReportUsersError = null;
      })
      .addCase(fetchTrainerTrialReportUsersData.fulfilled, (state, action) => {
        state.trainerTrialReportUsersLoading = false;
        state.trainerTrialReportUsers = action.payload;
      })
      .addCase(fetchTrainerTrialReportUsersData.rejected, (state, action) => {
        state.trainerTrialReportUsersLoading = false;
        state.trainerTrialReportUsersError = action.error.message;
      })
      .addCase(fetchAllDraftPlansData.pending, (state) => {
        state.plansLoading = true;
      })
      .addCase(fetchAllDraftPlansData.fulfilled, (state, action) => {
        state.plansLoading = false;
        state.draftPlans = action.payload;
      })
      .addCase(fetchAllDraftPlansData.rejected, (state, action) => {
        state.plansLoading = false;
        state.plansError = action.error.message;
      })

      .addCase(fetchOngoingOffersData.pending, (state) => {
        state.ongoingOffersLoading = true;
        state.ongoingOffersError = null;
      })
      .addCase(fetchOngoingOffersData.fulfilled, (state, action) => {
        state.ongoingOffersLoading = false;
        state.ongoingOffers = action.payload;
      })
      .addCase(fetchOngoingOffersData.rejected, (state, action) => {
        state.ongoingOffersLoading = false;
        state.ongoingOffersError = action.error.message;
      })

      .addCase(fetchPlanOffersData.pending, (state) => {
        state.plansLoading = true;
      })
      .addCase(fetchPlanOffersData.fulfilled, (state, action) => {
        state.plansLoading = false;
        state.plansData = action.payload;
      })
      .addCase(fetchPlanOffersData.rejected, (state, action) => {
        state.plansLoading = false;
        state.plansError = action.error.message;
      })

      .addCase(fetchOneDayPlansData.pending, (state) => {
        state.oneDayPlansLoading = true;
      })
      .addCase(fetchOneDayPlansData.fulfilled, (state, action) => {
        state.oneDayPlansLoading = false;
        state.oneDayPlansData = action.payload;
      })
      .addCase(fetchOneDayPlansData.rejected, (state, action) => {
        state.oneDayPlansLoading = false;
        state.oneDayPlansError = action.error.message;
      })

      .addCase(fetchODMStatsData.pending, (state) => {
        state.oneDayStatsLoading = true;
      })
      .addCase(fetchODMStatsData.fulfilled, (state, action) => {
        state.oneDayStatsLoading = false;
        state.oneDayStats = action.payload;
      })
      .addCase(fetchODMStatsData.rejected, (state, action) => {
        state.oneDayStatsLoading = false;
        state.oneDayStatsError = action.error.message;
      })

      .addCase(fetchMemberSubscriptionData.pending, (state) => {
        state.memberSubscriptionLoading = true;
      })
      .addCase(fetchMemberSubscriptionData.fulfilled, (state, action) => {
        state.memberSubscriptionLoading = false;
        state.memberSubscription = action.payload;
      })
      .addCase(fetchMemberSubscriptionData.rejected, (state, action) => {
        state.memberSubscriptionLoading = false;
        state.memberSubscriptionError = action.error.message;
      })

      .addCase(fetchTestingNumbersData.pending, (state) => {
        state.testingNumbersLoading = true;
      })
      .addCase(fetchTestingNumbersData.fulfilled, (state, action) => {
        state.testingNumbersLoading = false;
        state.testingNumbers = action.payload;
      })
      .addCase(fetchTestingNumbersData.rejected, (state, action) => {
        state.testingNumbersLoading = false;
        state.testingNumbersError = action.error.message;
      })

      .addCase(fetchUpgradeMembershipsData.pending, (state) => {
        state.upgradeMembershipsLoading = true;
      })
      .addCase(fetchUpgradeMembershipsData.fulfilled, (state, action) => {
        state.upgradeMembershipsLoading = false;
        state.upgradeMemberships = action.payload;
      })
      .addCase(fetchUpgradeMembershipsData.rejected, (state, action) => {
        state.upgradeMembershipsLoading = false;
        state.upgradeMembershipsError = action.error.message;
      })

      // PT (addon_pt) membership upgrade — ported from main
      .addCase(fetchUpgradePtMembershipsData.pending, (state) => {
        state.upgradePtMembershipsLoading = true;
        state.upgradePtMembershipsError = null;
      })
      .addCase(fetchUpgradePtMembershipsData.fulfilled, (state, action) => {
        state.upgradePtMembershipsLoading = false;
        state.upgradePtMemberships = action.payload;
      })
      .addCase(fetchUpgradePtMembershipsData.rejected, (state, action) => {
        state.upgradePtMembershipsLoading = false;
        state.upgradePtMembershipsError = action.error.message;
      })

      .addCase(fetchPtUpgradeAddonsData.pending, (state) => {
        state.ptUpgradeAddonsLoading = true;
        state.ptUpgradeAddonsError = null;
      })
      .addCase(fetchPtUpgradeAddonsData.fulfilled, (state, action) => {
        state.ptUpgradeAddonsLoading = false;
        state.ptUpgradeAddons = action.payload;
      })
      .addCase(fetchPtUpgradeAddonsData.rejected, (state, action) => {
        state.ptUpgradeAddonsLoading = false;
        state.ptUpgradeAddonsError = action.error.message;
      })

      .addCase(fetchBiomaxRegisteredMembersData.pending, (state) => {
        state.biomaxRegisteredMembersLoading = true;
      })
      .addCase(fetchBiomaxRegisteredMembersData.fulfilled, (state, action) => {
        state.biomaxRegisteredMembersLoading = false;
        state.biomaxRegisteredMembers = action.payload;
      })
      .addCase(fetchBiomaxRegisteredMembersData.rejected, (state, action) => {
        state.biomaxRegisteredMembersLoading = false;
        state.biomaxRegisteredMembersError = action.error.message;
      })

      .addCase(fetchAllAccessPlansData.pending, (state) => {
        state.allAccessPlansLoading = true;
      })
      .addCase(fetchAllAccessPlansData.fulfilled, (state, action) => {
        state.allAccessPlansLoading = false;
        state.allAccessPlans = action.payload;
      })
      .addCase(fetchAllAccessPlansData.rejected, (state, action) => {
        state.allAccessPlansLoading = false;
        state.allAccessPlansError = action.error.message;
      })

      .addCase(fetchRecurringSubscriptionsData.pending, (state) => {
        state.recurringSubscriptionLoading = true;
      })
      .addCase(fetchRecurringSubscriptionsData.fulfilled, (state, action) => {
        state.recurringSubscriptionLoading = false;
        state.recurringSubscription = action.payload;
      })
      .addCase(fetchRecurringSubscriptionsData.rejected, (state, action) => {
        state.recurringSubscriptionLoading = false;
        state.recurringSubscriptionError = action.error.message;
      })

      .addCase(fetchRecurringSubscriptionStatsData.pending, (state) => {
        state.recurringSubscriptionStatsLoading = true;
      })
      .addCase(
        fetchRecurringSubscriptionStatsData.fulfilled,
        (state, action) => {
          state.recurringSubscriptionStatsLoading = false;
          state.recurringSubscriptionStats = action.payload;
        }
      )
      .addCase(
        fetchRecurringSubscriptionStatsData.rejected,
        (state, action) => {
          state.recurringSubscriptionStatsLoading = false;
          state.recurringSubscriptionStatsError = action.error.message;
        }
      )

      .addCase(fetchWebsiteTabPrefenceData.pending, (state) => {
        state.websiteTabPrefenceLoading = true;
      })
      .addCase(fetchWebsiteTabPrefenceData.fulfilled, (state, action) => {
        state.websiteTabPrefenceLoading = false;
        state.websiteTabPrefence = action.payload;
      })
      .addCase(fetchWebsiteTabPrefenceData.rejected, (state, action) => {
        state.websiteTabPrefenceLoading = false;
        state.websiteTabPrefenceError = action.error.message;
      })

      .addCase(fetchCentralisedPlansData.pending, (state) => {
        state.centralisedPlansLoading = true;
      })
      .addCase(fetchCentralisedPlansData.fulfilled, (state, action) => {
        state.centralisedPlansLoading = false;
        state.centralisedPlans = action.payload;
      })
      .addCase(fetchCentralisedPlansData.rejected, (state, action) => {
        state.centralisedPlansLoading = false;
        state.centralisedPlansError = action.error.message;
      })

      .addCase(fetchCentralisedPlanCategoriesData.pending, (state) => {
        state.centralisedPlanCategoriesLoading = true;
      })
      .addCase(
        fetchCentralisedPlanCategoriesData.fulfilled,
        (state, action) => {
          state.centralisedPlanCategoriesLoading = false;
          state.centralisedPlanCategories = action.payload;
        }
      )
      .addCase(fetchCentralisedPlanCategoriesData.rejected, (state, action) => {
        state.centralisedPlanCategoriesLoading = false;
        state.centralisedPlanCategoriesError = action.error.message;
      })

      .addCase(fetchAllAddonDraftsData.pending, (state) => {
        state.addonDraftsLoading = true;
      })
      .addCase(fetchAllAddonDraftsData.fulfilled, (state, action) => {
        state.addonDraftsLoading = false;
        state.addonDrafts = action.payload;
      })
      .addCase(fetchAllAddonDraftsData.rejected, (state, action) => {
        state.addonDraftsLoading = false;
        state.addonDraftsError = action.error.message;
      })

      .addCase(fetchAllPlanPauseData.pending, (state) => {
        state.planPauseLoading = true;
      })
      .addCase(fetchAllPlanPauseData.fulfilled, (state, action) => {
        state.planPauseLoading = false;
        state.planPause = action.payload;
      })
      .addCase(fetchAllPlanPauseData.rejected, (state, action) => {
        state.planPauseLoading = false;
        state.planPauseError = action.error.message;
      })

      .addCase(fetchMembershipPauseData.pending, (state) => {
        state.membershipPauseLoading = true;
      })
      .addCase(fetchMembershipPauseData.fulfilled, (state, action) => {
        state.membershipPauseLoading = false;
        state.membershipPause = action.payload;
      })
      .addCase(fetchMembershipPauseData.rejected, (state, action) => {
        state.membershipPauseLoading = false;
        state.membershipPauseError = action.error.message;
      })

      .addCase(fetchOfferAttributesData.pending, (state) => {
        state.offerAttributesLoading = true;
      })
      .addCase(fetchOfferAttributesData.fulfilled, (state, action) => {
        state.offerAttributesLoading = false;
        state.offerAttributes = action.payload;
      })
      .addCase(fetchOfferAttributesData.rejected, (state, action) => {
        state.offerAttributesLoading = false;
        state.offerAttributesError = action.error.message;
      })

      .addCase(fetchTriggersData.pending, (state) => {
        state.triggersLoading = true;
      })
      .addCase(fetchTriggersData.fulfilled, (state, action) => {
        state.triggersLoading = false;
        state.triggers = action.payload;
      })
      .addCase(fetchTriggersData.rejected, (state, action) => {
        state.triggersLoading = false;
        state.triggersError = action.error.message;
      })

      .addCase(fetchTriggersDaysData.pending, (state) => {
        state.triggersDaysLoading = true;
      })
      .addCase(fetchTriggersDaysData.fulfilled, (state, action) => {
        state.triggersDaysLoading = false;
        state.triggersDays = action.payload;
      })
      .addCase(fetchTriggersDaysData.rejected, (state, action) => {
        state.triggersDaysLoading = false;
        state.triggersDaysError = action.error.message;
      })

      .addCase(fetchInventoriesData.pending, (state) => {
        state.inventoriesLoading = true;
      })
      .addCase(fetchInventoriesData.fulfilled, (state, action) => {
        state.inventoriesLoading = false;
        state.inventories = action.payload;
      })
      .addCase(fetchInventoriesData.rejected, (state, action) => {
        state.inventoriesLoading = false;
        state.inventoriesError = action.error.message;
      })

      .addCase(fetchPlansData.pending, (state) => {
        state.plansLoadingV0 = true;
      })
      .addCase(fetchPlansData.fulfilled, (state, action) => {
        state.plansLoadingV0 = false;
        state.plansV0 = action.payload;
      })
      .addCase(fetchPlansData.rejected, (state, action) => {
        state.plansLoadingV0 = false;
        state.plansErrorV0 = action.error.message;
      })

      .addCase(fetchThreeDayPTTrialData.pending, (state) => {
        state.threeDayPTTrialLoading = true;
      })
      .addCase(fetchThreeDayPTTrialData.fulfilled, (state, action) => {
        state.threeDayPTTrialLoading = false;
        state.threeDayPTTrial = action.payload;
      })
      .addCase(fetchThreeDayPTTrialData.rejected, (state, action) => {
        state.threeDayPTTrialLoading = false;
        state.threeDayPTTrialError = action.error.message;
      })

      .addCase(fetchSubscriptionExtensionRequestsData.pending, (state) => {
        state.subscriptionExtensionRequestsLoading = true;
      })
      .addCase(
        fetchSubscriptionExtensionRequestsData.fulfilled,
        (state, action) => {
          state.subscriptionExtensionRequestsLoading = false;
          state.subscriptionExtensionRequests = action.payload;
        }
      )
      .addCase(
        fetchSubscriptionExtensionRequestsData.rejected,
        (state, action) => {
          state.subscriptionExtensionRequestsLoading = false;
          state.subscriptionExtensionRequestsError = action.error.message;
        }
      )

      .addCase(fetchManualExtensionDataData.pending, (state) => {
        state.manualExtensionDataLoading = true;
      })
      .addCase(fetchManualExtensionDataData.fulfilled, (state, action) => {
        state.manualExtensionDataLoading = false;
        state.manualExtensionData = action.payload;
      })
      .addCase(fetchManualExtensionDataData.rejected, (state, action) => {
        state.manualExtensionDataLoading = false;
        state.manualExtensionDataError = action.error.message;
      })

      .addCase(fetchMemberDetailsByMobileData.pending, (state) => {
        state.memberDetailsByMobileLoading = true;
      })
      .addCase(fetchMemberDetailsByMobileData.fulfilled, (state, action) => {
        state.memberDetailsByMobileLoading = false;
        state.memberDetailsByMobile = action.payload;
      })
      .addCase(fetchMemberDetailsByMobileData.rejected, (state, action) => {
        state.memberDetailsByMobileLoading = false;
        state.memberDetailsByMobileError = action.error.message;
      })

      .addCase(fetchMemberTrialHistoryData.pending, (state) => {
        state.memberTrialHistoryLoading = true;
      })
      .addCase(fetchMemberTrialHistoryData.fulfilled, (state, action) => {
        state.memberTrialHistoryLoading = false;
        state.memberTrialHistory = action.payload;
      })
      .addCase(fetchMemberTrialHistoryData.rejected, (state, action) => {
        state.memberTrialHistoryLoading = false;
        state.memberTrialHistoryError = action.error.message;
      })

      .addCase(fetchTrialSessionDetailsData.pending, (state) => {
        state.trialSessionDetailsLoading = true;
        state.trialSessionDetailsError = null;
      })
      .addCase(fetchTrialSessionDetailsData.fulfilled, (state, action) => {
        state.trialSessionDetailsLoading = false;
        state.trialSessionDetails = action.payload;
      })
      .addCase(fetchTrialSessionDetailsData.rejected, (state, action) => {
        state.trialSessionDetailsLoading = false;
        state.trialSessionDetailsError = action.error.message;
      })
      // Member Diet Stats
      .addCase(fetchMemberDietStats.pending, (state) => {
        state.memberDietStatsLoading = true;
        state.memberDietStatsError = null;
      })
      .addCase(fetchMemberDietStats.fulfilled, (state, action) => {
        state.memberDietStatsLoading = false;
        state.memberDietStats = action.payload;
      })
      .addCase(fetchMemberDietStats.rejected, (state, action) => {
        state.memberDietStatsLoading = false;
        state.memberDietStatsError = action.error.message;
      })
      // Member TME Diet Stats
      .addCase(fetchMemberTmeDietStats.pending, (state) => {
        state.memberTmeDietStatsLoading = true;
        state.memberTmeDietStatsError = null;
      })
      .addCase(fetchMemberTmeDietStats.fulfilled, (state, action) => {
        state.memberTmeDietStatsLoading = false;
        state.memberTmeDietStats = action.payload;
      })
      .addCase(fetchMemberTmeDietStats.rejected, (state, action) => {
        state.memberTmeDietStatsLoading = false;
        state.memberTmeDietStatsError = action.error.message;
      })
      // Nutrition Logs 14 Days
      .addCase(fetchNutritionLogs14Days.pending, (state) => {
        state.nutritionLogs14DaysLoading = true;
        state.nutritionLogs14DaysError = null;
      })
      .addCase(fetchNutritionLogs14Days.fulfilled, (state, action) => {
        state.nutritionLogs14DaysLoading = false;
        state.nutritionLogs14Days = action.payload;
      })
      .addCase(fetchNutritionLogs14Days.rejected, (state, action) => {
        state.nutritionLogs14DaysLoading = false;
        state.nutritionLogs14DaysError = action.error.message;
      })
      .addCase(fetchTrainerPTRenewalsData.pending, (state) => {
        state.trainerPTRenewalsLoading = true;
        state.trainerPTRenewalsError = null;
      })
      .addCase(fetchTrainerPTRenewalsData.fulfilled, (state, action) => {
        state.trainerPTRenewalsLoading = false;
        state.trainerPTRenewals = action.payload;
      })
      .addCase(fetchTrainerPTRenewalsData.rejected, (state, action) => {
        state.trainerPTRenewalsLoading = false;
        state.trainerPTRenewalsError = action.error.message;
      })

      .addCase(fetchPaymentLinkHomeStatData.pending, (state) => {
        state.paymentLinkHomeStatLoading = true;
        state.paymentLinkHomeStatError = null;
      })
      .addCase(fetchPaymentLinkHomeStatData.fulfilled, (state, action) => {
        state.paymentLinkHomeStatLoading = false;
        state.paymentLinkHomeStatError = null;
        state.paymentLinkHomeStat = action.payload;
      })
      .addCase(fetchPaymentLinkHomeStatData.rejected, (state, action) => {
        state.paymentLinkHomeStatLoading = false;
        state.paymentLinkHomeStatError = action.error.message;
      })

      // Three Day PT Member Details
      .addCase(fetchThreeDayPTMemberDetailsData.pending, (state) => {
        state.threeDayPTMemberDetailsLoading = true;
        state.threeDayPTMemberDetailsError = null;
      })
      .addCase(fetchThreeDayPTMemberDetailsData.fulfilled, (state, action) => {
        state.threeDayPTMemberDetailsLoading = false;
        state.threeDayPTMemberDetails = action.payload;
      })
      .addCase(fetchThreeDayPTMemberDetailsData.rejected, (state, action) => {
        state.threeDayPTMemberDetailsLoading = false;
        state.threeDayPTMemberDetailsError = action.error.message;
      })

      // Three Day PT Session Stats
      .addCase(fetchThreeDayPTSessionStatsData.pending, (state) => {
        state.threeDayPTSessionStatsLoading = true;
        state.threeDayPTSessionStatsError = null;
      })
      .addCase(fetchThreeDayPTSessionStatsData.fulfilled, (state, action) => {
        state.threeDayPTSessionStatsLoading = false;
        state.threeDayPTSessionStats = action.payload;
      })
      .addCase(fetchThreeDayPTSessionStatsData.rejected, (state, action) => {
        state.threeDayPTSessionStatsLoading = false;
        state.threeDayPTSessionStatsError = action.error.message;
      })
      // Three Day PT Members Stats
      .addCase(fetchThreeDayPTMembersStatsData.pending, (state) => {
        state.threeDayPTMembersStatsLoading = true;
        state.threeDayPTMembersStatsError = null;
      })
      .addCase(fetchThreeDayPTMembersStatsData.fulfilled, (state, action) => {
        state.threeDayPTMembersStatsLoading = false;
        state.threeDayPTMembersStats = action.payload;
      })
      .addCase(fetchThreeDayPTMembersStatsData.rejected, (state, action) => {
        state.threeDayPTMembersStatsLoading = false;
        state.threeDayPTMembersStatsError = action.error.message;
      })

      // Addon Categories
      .addCase(fetchAddonCategoriesData.pending, (state) => {
        state.addonCategoriesLoading = true;
        state.addonCategoriesError = null;
      })
      .addCase(fetchAddonCategoriesData.fulfilled, (state, action) => {
        state.addonCategoriesLoading = false;
        state.addonCategories = action.payload;
      })
      .addCase(fetchAddonCategoriesData.rejected, (state, action) => {
        state.addonCategoriesLoading = false;
        state.addonCategoriesError = action.error.message;
      })

      // Addon Carry Items
      .addCase(fetchAddonCarryItemsData.pending, (state) => {
        state.addonCarryItemsLoading = true;
        state.addonCarryItemsError = null;
      })
      .addCase(fetchAddonCarryItemsData.fulfilled, (state, action) => {
        state.addonCarryItemsLoading = false;
        state.addonCarryItems = action.payload;
      })
      .addCase(fetchAddonCarryItemsData.rejected, (state, action) => {
        state.addonCarryItemsLoading = false;
        state.addonCarryItemsError = action.error.message;
      })

      // Addon Benefits
      .addCase(fetchAddonBenefitsData.pending, (state) => {
        state.addonBenefitsLoading = true;
        state.addonBenefitsError = null;
      })
      .addCase(fetchAddonBenefitsData.fulfilled, (state, action) => {
        state.addonBenefitsLoading = false;
        state.addonBenefits = action.payload;
      })
      .addCase(fetchAddonBenefitsData.rejected, (state, action) => {
        state.addonBenefitsLoading = false;
        state.addonBenefitsError = action.error.message;
      });
  },
});

export default planSlice.reducer;
